<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="title">
        <span slot="label"><a-tooltip>{{ $t('名称') }}<template
          slot="title">{{ $t('名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.title" :maxLength="255" :placeholder="$t('请输入')+'名称'">
          <locale-field-button
            slot="suffix"
            class="ant-input-suffix-button"
            v-model="form.localeFieldMap['title']"
            input-type="input"
            table-name="community_report_reason"
            table-field="title"
            :field-value="form.title"/>
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="type">
        <span slot="label"><a-tooltip>{{ $t('内容类型') }}<template
          slot="title">{{ $t('内容类型') }}</template></a-tooltip> </span>
        <a-radio-group v-model="form.type" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.ReportTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item prop="sort">
        <span slot="label"><a-tooltip>{{ $t('排序') }}<template
          slot="title">{{ $t('排序') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.sort" :max="10000" :placeholder="$t('请输入')+'排序'">
        </a-input-number>
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label"><a-tooltip>{{ $t('状态') }}<template
          slot="title">{{ $t('状态') }}</template></a-tooltip> </span>
        <a-radio-group v-model="form.status" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.StatusEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {
  getCommunityReportReason,
  addCommunityReportReason,
  updateCommunityReportReason
} from '@/api/community/reportReason'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'
import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
    LocaleFieldButton
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        id: null,
        title: null,
        type: 3,
        sort: 1,
        status: 1,
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        title: [{ required: true, message: this.$t('名称') + this.$t('不能为空'), trigger: 'blur' }],
        type: [{
          required: true,
          message: this.$t('内容类型') + this.$t('不能为空'),
          trigger: 'change'
        }],
        sort: [{ required: true, message: this.$t('排序') + this.$t('不能为空'), trigger: 'blur' }],
        status: [{ required: true, message: this.$t('状态') + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        title: null,
        type: 3,
        sort: 1,
        status: 1,
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityReportReason({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityReportReason(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityReportReason(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
